import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ServicesState } from '../reducers/services.reducer';

export const servicesState: any = createFeatureSelector<ServicesState>('services');

export const servicesTable = createSelector(servicesState, (state: any) => state.servicesTable);
export const servicesByAppId = createSelector(servicesState, (state: any) => state.servicesByAppId);

export const servicesOrder = createSelector(servicesState, (state: any) => state.servicesOrder);

export const tableFields = createSelector(servicesState, (state: any) => state.fields);
export const parentTableFields = createSelector(servicesState, (state: any) => state.parentFields);
export const tableFieldsForFormula = createSelector(servicesState, (state: any) => state.tblFields);

export const tableFieldsForDM = createSelector(servicesState, (state: any) => state.tblFields);

export const totalServRecords = createSelector(servicesState, (state: any) => {
  return state.totalServRecords;
});
